module.exports = __webpack_public_path__ + "img/object-mark13.860fa297.png";